import { z } from 'zod';
import { addressRequiredSchema } from '../addresses/index.js';
export const locationCreateSchema = z.object({
    name: z
        .string('Name is required')
        .min(1, 'Name is required')
        .describe('The name of the location used to easily identify it'),
    isActive: z.boolean(),
    address: addressRequiredSchema,
});
export const locationUpdateSchema = locationCreateSchema.clone();
